/**
 * @author wuTao
 * @description 课堂助手-远程认证查看
 * @Date 2020/12/25
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './columns'
import ClassStudentAideInfo from './../classStudentAide/classStudentAideInfo'
import {modelUtils} from '@/utils'
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {classStudentRemoteAuthExcelColumns} from '../../excelColumns';
import moment from "moment";

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizModal} = component_tool;
let {Session} = utils_tool;
const getClassAideEntityInfo = (history) => {
  let record = {}
  if (history.location) {
    if (history.location && history.location.record) {
      record = history.location.record;
      Session.set('classAideEntityInfo', record)
    } else {
      record = Session.get('classAideEntityInfo') || 0
    }
  } else {
    record = Session.get('classAideEntityInfo') || 0
  }
  return record
}
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD') : '';
}
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}

class ClassStudentRemoteAuthList extends WizContainer {
  componentName = 'classStudentRemoteAuthList';

  constructor(props) {
    super(props);
    this.state = {
      selectedClassRemoteAuthRows: [],//选择的学员
    };
    this.classAideEntityInfo = getClassAideEntityInfo(props.history);
  }

  propsAndStateOnChange = {};


  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columns = classStudentRemoteAuthExcelColumns;
    if (o['success']) {
      let data = o['data'];
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _d.jobState = d.jobState ===1 ? "在职" : d.jobState ===0 ?  "离职" : "";
        _d.leaveState = d.leaveState ===1 ? "是" : d.leaveState ===0 ?  "否" : "";
        _d.authDate = d.authDate ? formatterDate(d.authDate) : "";
        _d.authTime = (d.startDate ? formatterTime(d.startDate) + ' ~ ' : '') + (d.endDate ? formatterTime(d.endDate) : '');
        _d.isConfig = d.isConfig ===1 ? "是" : d.isConfig ===0 ?  "否" : "";
        _d.authState = d.authState ===0 ? "未开始" : d.authState ===1 ?  "已开始" : d.authState ===2 ?  "认证中" : d.authState ===3 ?  "未参考" : d.authState ===4 ?  "已完成" :  d.authState ===6 ?  "已作废" :"可回看";
        _d.pass = d.pass ===1 ? "已通过" : d.pass ===0 ?  "未通过" : "";
        _data.push(_d);
      });
      WizBrowserExport({
        title: '班级学员远程认证记录信息',
        sheetName: '班级学员远程认证记录信息',
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: '班级学员远程认证记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    this.classAideEntityInfo = getClassAideEntityInfo(this.props.history);
    const {classStudentManagementLoading} = this.props;
    let record = this.classAideEntityInfo;
    let classInfoId = null;
    let entityId = null;
    let classAideId = null;
    if (record) {
      classInfoId = record.classId;
      entityId = record.id;
      classAideId = record.classAideId;
    }
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedClassRemoteAuthRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
      classAideEntityInfo:record,
      classInfoId,
      classAideId,
      entityId,
    });
    let _reduxTemplateConfig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      classInfoId,
      entityId,
      classAideId,
      apiDataFormat: {
        exportClassStudentRemoteAuth: this._handleFile,
        publishState : this._handleCMD,
        updateAuthState : this._handleCMD,
      },
    });

    return (
      <>
        <WizSpin tip={"加载中"} spinning={classStudentManagementLoading}>
          <ClassStudentAideInfo {...record} />
          <WizCard title={'环节记录'}>
            <WizReduxTemplate  {..._reduxTemplateConfig} />
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classStudentManagement} = state;
  const load = modelUtils.getLoadingState(state, ['classStudentManagement']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ClassStudentRemoteAuthList);
